// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ti0A8","xHidden":"styles_xHidden__D5Gmc","yHidden":"styles_yHidden__rvLr9"};